const tryCatch = (fn) => (...args) => {
	try {
		return fn(...args);
	} catch (e) {
		return null;
	}
};

const fallbackStorage = { getItem() { }, setItem() { }, clear() { }, removeItem() { } };

let localStorage = window.localStorage;

if (window.Modernizr && !window.Modernizr.localstorage) {
	localStorage = fallbackStorage;
}

// safe to use local storage methods
const getItem = tryCatch(localStorage.getItem.bind(localStorage));
const setItem = tryCatch(localStorage.setItem.bind(localStorage));
const clear = tryCatch(localStorage.clear.bind(localStorage));
const removeItem = tryCatch(localStorage.removeItem.bind(localStorage));

export default {
	getItem,
	setItem,
	clear,
	removeItem,
};



// WEBPACK FOOTER //
// ./src/shared/util/localStorage.js